import { createSelector } from 'reselect';
import { toVertexLogoURL } from '~/utils/transform.js';

export const getRoot = state => state.get('auth') || state;

export const getToken = state => getRoot(state).get('access_token');

export const getBaseURL = state => getRoot(state).get('baseURL');

export const getProductID = state => getRoot(state).get('product_id');

// User
const getUser = state => getRoot(state).get('user');

export const getUserID = state => getUser(state).get('id');

export const getUserName = state => getUser(state).get('name');

export const getUserLogoID = state => getUser(state).get('logo_id');

export const getUserLogoURL = state => getUser(state).get('logo_url');

export const isAuthenticated = createSelector(
    [getToken, getUserID],
    (token, userID) => Boolean(token) && Boolean(userID),
);

export const getUserData = (state) => {
    const userData = {
        id: getUserID(state),
        name: getUserName(state),
        logo_url: toVertexLogoURL({
            logo_id: getUserLogoID(state),
            logo_url: getUserLogoURL(state),
        }),
    };
    return userData;
};
